import React, { Component } from "react";
import {
  Breadcrumb,
  Select,
  DatePicker,
  Button,
  message,
  Input,
  Progress,
} from "antd";
import { ACTION_STATUS } from "../../../../../utils/ActionStatus";
import "./MeetingAndTrainingDashboard.css";
import MeetingAndTrainingGrid from "./MeetingAndTrainingGrid";
import AddOrEditMeetingAndTrainingModalDialog from "./AddOrEditMeetingAndTrainingModalDialog";
import DelMeetingAndTrainingModalDialog from "./DelMeetingAndTrainingModalDialog";
import CopMeetingAndTrainingModalDialog from "./CopMeetingAndTrainingModalDialog";
import AnswereeSelectDialog from "./AnswereeSelectDialog";
import OperationRecordDialog from "../../../common/operationRcd/components/OperationRecordDialog";

class MeetingAndTrainingDashboard extends Component {
  componentDidMount() {
    const { cpty, functiontype, fundandcompany, userName, status } =
      this.props.meetingAndTrainingQueryFields;
    this.props.loadMeetingAndTrainingInfo({
      cpty: undefined,
      functiontype: undefined,
      fundandcompany: undefined,
      userName: undefined,
      status: "Active",
    });
    this.props.loadMeetingAndTrainingGroupInfo({ ismerge: "1" });
    this.props.loadInstituteUserAccounts({});
  }

  componentDidUpdate() {
    const {
      // query
      loadMeetingAndTrainingInfoActionStatus,
      loadMeetingAndTrainingInfoResp,
    } = this.props;

    if (loadMeetingAndTrainingInfoActionStatus === ACTION_STATUS.SUCCESS) {
      this.props.initLoadMeetingAndTrainingInfoActionStatus();
    }
    if (loadMeetingAndTrainingInfoActionStatus === ACTION_STATUS.ERROR) {
      let err = "Load User Access Info failed";
      if (
        !!loadMeetingAndTrainingInfoResp &&
        !!loadMeetingAndTrainingInfoResp.respMessage
      ) {
        err = loadMeetingAndTrainingInfoResp.respMessage;
      }
      message.error(err);
      this.props.initLoadMeetingAndTrainingInfoActionStatus();
    }
  }

  onInputChange = ({ name, value }) => {
    this.props.onQueryInputChange({ name, value });
  };

  addOrEditBtnOnClicked = (mode) => {
    if (mode === "ADD") {
      this.props.openAddOrEditMeetingAndTrainingModal(mode, null);
    } else {
      const { selectedMeetingAndTrainingInfoArray } = this.props;
      if (selectedMeetingAndTrainingInfoArray.length !== 1) {
        message.warning("Please choose one and only one User Access Info");
        return;
      }
      const currentMeetingAndTrainingInfo =
        selectedMeetingAndTrainingInfoArray[0];
      this.props.openAddOrEditMeetingAndTrainingModal(
        mode,
        currentMeetingAndTrainingInfo
      );
    }
  };
  copyAllBtnOnClicked = () => {
    const { selectedMeetingAndTrainingInfoArray } = this.props;
    if (selectedMeetingAndTrainingInfoArray.length !== 1) {
      message.warning("Please choose one and only one User Access Info");
      return;
    }
    const currentMeetingAndTrainingInfo =
      selectedMeetingAndTrainingInfoArray[0];
    this.props.openCopMeetingAndTrainingModal(currentMeetingAndTrainingInfo);
  };

  delBtnOnClicked = (mode) => {
    const { selectedMeetingAndTrainingInfoArray } = this.props;
    if (selectedMeetingAndTrainingInfoArray.length !== 1) {
      message.warning("Please choose one and only one User Access Info");
      return;
    }
    const currentMeetingAndTrainingInfo =
      selectedMeetingAndTrainingInfoArray[0];
    this.props.openDelMeetingAndTrainingModal(
      currentMeetingAndTrainingInfo,
      mode
    );
  };

  refreshBtnOnClicked = () => {
    const { title, functiontype, fundandcompany, userName, status } =
      this.props.meetingAndTrainingQueryFields;
    this.props.loadMeetingAndTrainingInfo({
      title,
      functiontype,
      fundandcompany,
      userName,
      status,
    });
  };

  selAnswereeButtonOnClicked = () => {
    const { selectedMeetingAndTrainingInfoArray } = this.props;

    if (selectedMeetingAndTrainingInfoArray.length !== 1) {
      message.warning("Please select one questionnaire!");
      return;
    }

    this.props.loadUserAccounts(); // 每次打开页面需要先刷新userAccount
    this.props.openAnswereeSelectModalDialog();
  };

  // 操作记录页面，自定义需要展示的列
  opRcdCustomColumns = [
    "operator",
    "operateTime",
    "dataId",
    "operateType",
    "comments",
    "before",
    "after",
  ];

  render() {
    const {
      statusOptions,
      meetingAndTrainingOptions,
      meetingAndTrainingQueryFields,
      loadMeetingAndTrainingInfoActionStatus,
    } = this.props;

    const { userName, status } = meetingAndTrainingQueryFields;

    const refreshBtnIsLoading =
      loadMeetingAndTrainingInfoActionStatus === ACTION_STATUS.LOGINING;

    return (
      <div className="MeetingAndTrainingWrapper">
        <div className="breadcrumbWrapper">
          <Breadcrumb>
            <Breadcrumb.Item></Breadcrumb.Item>
            <Breadcrumb.Item>Training</Breadcrumb.Item>
          </Breadcrumb>
        </div>
        <div className="OperationBar">
          <div className="breadcrumbWrapper">
            <Breadcrumb>
              <Breadcrumb.Item> Search by:</Breadcrumb.Item>
            </Breadcrumb>
          </div>

          <Input
            size="small"
            style={{ width: 150, marginLeft: 10 }}
            placeholder="Title"
            onPressEnter={this.refreshBtnOnClicked}
            onChange={(event) => {
              this.onInputChange({ name: "title", value: event.target.value });
            }}
          />
          {/* <Input 
                        placeholder="Function"
                        size="small"
                        style={{ width: 150, marginLeft: 10 }}
                        onPressEnter={this.refreshBtnOnClicked}
                        onChange={(event) => {
                            this.onInputChange({ name: 'functiontype', value: event.target.value })
                        }} 
                    />
                    <Input 
                        placeholder="Fund/Co."
                        size="small"
                        style={{ width: 150, marginLeft: 10 }}
                        onPressEnter={this.refreshBtnOnClicked}
                        onChange={(event) => {
                            this.onInputChange({ name: 'fundandcompany', value: event.target.value })
                        }} 
                    />
                    <Input 
                        placeholder="User"
                        size="small"
                        style={{ width: 150, marginLeft: 10 }}
                        onPressEnter={this.refreshBtnOnClicked}
                        onChange={(event) => {
                            this.onInputChange({ name: 'userName', value: event.target.value })
                        }} 
                    /> */}
          {/* <Select
                        allowClear
                        showSearch
                        size='small'
                        // --value={!user ? undefined : user}
                        style={{marginLeft: 10, width: 150}}
                        //onChange={(value) => this.onInputChange({name: 'userName', value: value})}
                        onChange={(val) => {
                            this.onInputChange({ name: 'userName', value: val })
                        }} 
                        placeholder="Employee">
                        {meetingAndTrainingOptions}
                    </Select> */}
          {/* <Select
                        allowClear
                        size='small'
                        style={{ width: 150, marginLeft: 10 }}
                        onChange={(val) => {
                            this.onInputChange({ name: 'status', value: val })
                        }} 
                        placeholder="Status">
                        {statusOptions}
                    </Select> */}
          {/* <DatePicker 
                      allowClear={true}
                      size='small'
                      style={{ width: 150, marginLeft: 10 }}
                      placeholder="Inv Date Start"
                      onChange={(invDateStart, dateString) => {
                        this.onInputChange({ name: 'invDateStart', value: dateString });
                      }}
                    /> */}
          {/* <DatePicker 
                      allowClear={true}
                      size='small'
                      style={{ width: 150, marginLeft: 10 }}
                      placeholder="Inv Date End"
                      onChange={(invDateEnd, dateString) => {
                        this.onInputChange({ name: 'invDateEnd', value: dateString });
                      }}
                    /> */}
          <Button
            onClick={this.refreshBtnOnClicked}
            loading={refreshBtnIsLoading}
            size="small"
            style={{ marginLeft: 10 }}
            type="primary"
            icon="search"
          />
          <Button
            onClick={() => this.addOrEditBtnOnClicked("ADD")}
            size="small"
            style={{ fontSize: 10, marginLeft: 10 }}
            className="positive-button"
          >
            Add
          </Button>
          <Button
            onClick={() => this.addOrEditBtnOnClicked("COPY")}
            size="small"
            style={{ fontSize: 10, marginLeft: 10 }}
            className="positive-button"
          >
            Copy
          </Button>
          {/* <Button 
                        onClick={()=>this.copyAllBtnOnClicked()} 
                        size='small'
                        style={{ fontSize: 10, marginLeft: 10 }}
                        className='positive-button'>
                        Copy All
                    </Button> */}
          {/* <Button 
                        onClick={()=>this.addOrEditBtnOnClicked('EDIT')} 
                        size='small'
                        style={{ fontSize: 10, marginLeft: 10 }}
                        type='primary'>
                        Edit Event
                    </Button> */}
          <Button
            onClick={() => this.addOrEditBtnOnClicked("EDITALL")}
            size="small"
            style={{ fontSize: 10, marginLeft: 10 }}
            type="primary"
          >
            Edit Series
          </Button>
          {/* <Button 
                        onClick={()=>this.delBtnOnClicked('inactive')} 
                        size='small'
                        style={{ fontSize: 10, marginLeft: 10 }}
                        type='primary'>
                        Inactivate User
                    </Button> */}
          <Button
            onClick={() => this.delBtnOnClicked("del")}
            size="small"
            style={{ fontSize: 10, marginLeft: 10 }}
            className="negative-button"
          >
            Del
          </Button>
          {/* <Button 
                        onClick={this.selAnswereeButtonOnClicked} 
                        size='small'
                        style={{ marginLeft: 10 }}
                        type='primary'>
                        Select Answeree
                    </Button> */}
          <Button
            onClick={() => this.delBtnOnClicked("send")}
            size="small"
            style={{ marginLeft: 10 }}
            type="primary"
          >
            Send Email
          </Button>

          <Button
            onClick={() => this.delBtnOnClicked("Append")}
            size="small"
            style={{ fontSize: 10, marginLeft: 10 }}
            className="positive-button"
          >
            Append user
          </Button>
          <Button
            onClick={() => this.delBtnOnClicked("postponed")}
            size="small"
            style={{ marginLeft: 10 }}
            type="primary"
          >
            Extend
          </Button>
          {/* <Button 
                        onClick={()=>this.props.doOperationRecordAction({action:'OPEN_AND_QUERY', queryFields: {module: 'MeetingAndTraining'}, customColumns: this.opRcdCustomColumns})} 
                        size='small'
                        style={{ fontSize: 10, marginLeft: 10 }}
                        type='primary'>
                        Operation Record
                    </Button>  */}
        </div>

        <div className="MeetingAndTrainingGrid">
          <MeetingAndTrainingGrid {...this.props} />
        </div>
        <AddOrEditMeetingAndTrainingModalDialog {...this.props} />
        <DelMeetingAndTrainingModalDialog {...this.props} />
        <CopMeetingAndTrainingModalDialog {...this.props} />
        <OperationRecordDialog {...this.props} />
        <AnswereeSelectDialog {...this.props} />
      </div>
    );
  }
}

export default MeetingAndTrainingDashboard;
